<!--
 * @Author: alex.dai
 * @Date: 2023-04-12 10:07:22
 * @LastEditors: alex.dai
 * @LastEditTime: 2023-04-13 16:55:01
 * @FilePath: /new-frontend/src/components/order/OrderStatus.vue
 * @Description:
-->
<template>
  <span class="recharge-status">
    <Tag :color="nodeStateTagText.color">{{ nodeStateTagText.label }}</Tag>
  </span>
</template>
<script>
export default {
  name: 'OrderStatus',
  props: {
    nodeState: {
      type: Number,
      default: 0,
      required: true
    },
    tagInfo: {
      type: Array,
      default: () =>
        [{ value: '0',
          color: 'default',
          label: '未知' }],
      require: true

    }
  },
  computed: {
    nodeStateTagText () {
      return this.tagInfo.find(item => item.value === this.nodeState) || {
        color: 'default',
        label: '未知'
      }
    }
  }
}
</script>
